import { render, staticRenderFns } from "./LichSuAmThucList.vue?vue&type=template&id=49b198d6"
import script from "./LichSuAmThucList.vue?vue&type=script&lang=js"
export * from "./LichSuAmThucList.vue?vue&type=script&lang=js"
import style0 from "./LichSuAmThucList.vue?vue&type=style&index=0&id=49b198d6&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports